module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/partner/partner.component.scss
// module id = ./src/app/partner/partner.component.scss
// module chunks = main